<ion-content class="ion-padding">
    <ion-label class="ion-text-center ion-text-wrap" style="font-size: larger;">
        {{'360evaluation.evaluatorsLimit.title' | translate}}
    </ion-label>
    <br />
    <p [innerHTML]="evaluatorsLimitWarningMessage"></p>
    <p [innerHTML]="evaluatorsLimitImportantMessage"></p>
    <!-- INFO -->
    <div style="background: #F7F6F3;color: #000;padding: 16px;">
        <span [innerHTML]="evaluatorsLimitInfoSelectMessage"></span>.<br />
        <span>{{'360evaluation.evaluatorsLimit.infoLimitMessage' | translate}}: {{evaluationLimit}}</span><br />
        <span>{{'360evaluation.evaluatorsLimit.infoTotalMessage' | translate}}: {{usersView.length}}</span><br />

    </div>
    <br />
    <div style="display: flex;gap:10px;height: 30px;">
        <ion-checkbox label-placement="end" 
            [(ngModel)]="allSelected" 
            [indeterminate]="partialSelected"
            (click)="changeMasterCheckbox()"
            [disabled]="isLoading"
            >
        </ion-checkbox>
        <span>{{selectedToRemoval.length}} {{'360evaluation.evaluatorsLimit.selectedQuantity' | translate}}</span>
        <ion-button 
        color="warning" 
        mode="ios" 
        fill="clear" 
        (click)="cleanSelection()" 
        style="height: 15px;"
        [disabled]="isLoading"
        >
            {{'360evaluation.evaluatorsLimit.cleanSelected' | translate}}
        </ion-button>
    </div>
    <ion-card mode="ios" class="team-card">

        <ion-card-content class="ion-no-padding">
            <ion-grid class="team">
                <ion-row class="header">
                    <ion-col size="1" size-lg="1"></ion-col>
                    <ion-col size="1" size-lg="1"></ion-col>
                    <ion-col size="2.3" size-lg="2.3">
                        {{ 'generic.evaluee' | translate }}
                    </ion-col>
                    <ion-col size="1.5" size-lg="1.5">
                        {{ 'generic.rank' | translate }}
                    </ion-col>
                    <ion-col size="1.5" size-lg="1.5">
                        {{ 'generic.area' | translate }}
                    </ion-col>
                    <ion-col size="1.5" size-lg="1.5">
                        {{ 'generic.lineManager' | translate }}
                    </ion-col>
                    <ion-col size="1.5" size-lg="1.5">
                        <div *ngIf="!processConfig?.disableRelationColumn">
                            {{ 'generic.relationship' | translate }}
                        </div>
                    </ion-col>

                </ion-row>
                <div style="overflow-y: auto;height: 350px;">
                    <ion-row *ngFor="let user of usersView" class="users-list">
                        <ion-col class="ion-flexed" size="1" size-lg="1">
                            <ion-row class="button-actions">
                                <ion-checkbox label-placement="end" 
                                    [(ngModel)]="user.selectedToRemoval"
                                    (click)="changeCheckbox(user.userId,!user.selectedToRemoval)"
                                    [disabled]="isLoading"
                                    ></ion-checkbox>
                            </ion-row>
                        </ion-col>
                        <ion-col size="1" size-lg="1" size-xs="1">
                            <img [src]="getImageUrl(user.imageUrl)" default="" class="avatar" />
                        </ion-col>

                        <ion-col size="2.3" size-lg="2.3">
                            <h3>{{ user.name }}</h3>
                        </ion-col>

                        <ion-col size="1.5" size-lg="1.5">
                            <h3>{{ user.attribute2 ? user.attribute2 : '-' }}</h3>
                        </ion-col>

                        <ion-col size="1.5" size-lg="1.5">
                            <h3>{{ user.attribute1 ? user.attribute1 : '-' }}</h3>
                        </ion-col>

                        <ion-col size="1.5" size-lg="1.5">
                            <h3>{{ user.lineManager ? user.lineManager : '-' }}</h3>
                        </ion-col>

                        <ion-col size="1.5" size-lg="1.5">
                            <div *ngIf="!processConfig?.disableRelationColumn">
                                <span *ngIf="!user.isManagerEvaluation">360</span>
                                <span *ngIf="user.isManagerEvaluation">
                                    {{ 'generic.manager' | translate }}
                                </span>
                            </div>
                        </ion-col>


                    </ion-row>
                </div>

            </ion-grid>
        </ion-card-content>
    </ion-card>
</ion-content>


<ion-footer mode="ios" style="padding-left: 16px;padding-right: 16px;">
    <ion-toolbar mode="ios">
        <ion-row>
            <div style="display: flex;justify-content: space-between;width: 100%;">
                <ion-button mode="ios" color="secondary" fill="outline" (click)="dismiss()" [disabled]="isLoading">
                    {{ 'generic.goBack' | translate }}
                </ion-button>
                <ion-button color="primary" mode="ios" [fill]="isLoading? 'outline' : 'solid'" (click)="save()"
                    [disabled]="selectedToRemoval.length != excedentUsers || isLoading">
                    <div *ngIf="isLoading" style="display: flex;align-items: center;">
                        {{'360evaluation.evaluatorsLimit.saving' | translate}}&nbsp;
                        <ion-spinner
                            name="crescent"
                            color="primary"
                            >
                        </ion-spinner>
                    </div>
                    
                    <span *ngIf="!isLoading">
                        {{'360evaluation.evaluatorsLimit.continue' | translate}}
                    </span>

                </ion-button>
            </div>
        </ion-row>
    </ion-toolbar>
</ion-footer>